import Axios from 'axios'
import State from './state'
import Router from '../router'
import { API } from './constants'
import Notify from '../services/notify'

export default {
	getLoggedUser() {
		return State.user;
	},
	getToken() {
		return localStorage.getItem('token');
	},
	setToken(token) {
		localStorage.setItem('token', token);
	},
	clearToken() {
		localStorage.removeItem('token');
	},
	authenticate(fromLogin) {
		return new Promise((resolve) => {
			if(!this.isLoggedIn() && this.getToken()) {
				State.loading = true;
				Axios.post(API.AUTHENTICATE, {
					token: this.getToken()
				}).then(response => {
					Notify.success.loginSuccess();
					State.user = response.data;
					if(State.previousRoute) {
						Router.push(State.previousRoute);
					} else {
						if(fromLogin) {
							Router.push({ name: 'home' });
						}
					}
				}).catch(() => {
					this.logout();
				}).finally(() => {
					State.loading = false;
					resolve();
				});
			} else {
				resolve();
			}
		});
	},
	login(username, password) {
		State.loading = true;
		Axios.post(API.LOGIN, {
			username: username,
			password: password
		}).then(response => {
			this.setToken(response.data.token);
			this.authenticate(true);
		}).catch(() => {
			Notify.error.loginFailed();
			this.clearToken();
			State.loading = false;
		});
	},
	logout() {
		if(State.user) {
			Axios.post(API.LOGOUT, {
				id: this.getLoggedUser().id
			}, {
				headers: {
					Authorization: this.getToken()
				}
			});    
		}
		State.user = null;
		this.clearToken();
		Router.push({ name: 'login'});
		
	},
	isLoggedIn() {
		return State.user;
	},
	isType(userType) {
		return State.user && State.user.type == userType;
	},
}



